export default __webpack_public_path__ + "static/media/Search.dd9de63b.svg";